<template>
  <div class="position-fixed top-0 left-0 w-100 h-100" style="z-index: 9999">
    <div class="filter w-100 h-100" @click="$store.state.contractStore.editedItem=null"></div>
    <div class="position-fixed bg-white p-5 shadow-lg top-0 h-100 overflow-auto w-800px d-flex flex-column" style="right:0">
      <div class="d-flex justify-content-between align-items-center">
        <h1 class="mb-0 text-uppercase text-primary">{{ trans("Modifier l'objet") }} {{ trans(item.name) }}</h1>
        <div>
        </div>
        <div class="btn btn-danger btn-xs ms-5 btn-icon" @click="$store.state.contractStore.editedItem=null">
          <i class="fad fa-times"></i>
        </div>
      </div>
      <div class="text-uppercase text-muted fw-bolder my-2 fs-2">
        {{ alias }}
      </div>

      <div class="row">
        <div class="col col-4">
          <label class="fw-bolder">Nom</label>
          <div class="position-relative">
            <input type="text" v-model="item.name" class="form-control form-control-solid" placeholder="Nom">

          </div>
        </div>
      </div>

      <div class="flex-grow-1 my-5">
        <div class="row mt-5">
          <template v-for="property in item.properties">
            <AvenantPropertyManager class="col col-4" :allowObjectEdition="false" :itemUuid="item.uuid" :propertyUuid="property.uuid" :type="property.model.type"/>
          </template>
        </div>
      </div>
      <div class="flex-grow-1 d-flex justify-content-center align-items-center" v-if="item.model.className === 'Asset'">
        <div class="btn btn-danger" @click="compare">
          <i class="fad fa-balance-scale"></i>
          Comparer les offres
        </div>
      </div>
      <div class="d-flex justify-content-end py-5">
        <div class="btn btn-primary" @click="updateEditedItem">
          <i class="fad fa-save"></i>
          Enregistrer
        </div>
      </div>

    </div>
  </div>
</template>

<script lang="ts">
import {Vue, Component, Prop} from 'vue-property-decorator';
import AvenantPropertyManager from "@/views/Income/Avenant/Components/AvenantPropertyManager.vue";

@Component({
  components: {AvenantPropertyManager}
})
export default class AvenantItemEditor extends Vue {
  @Prop() item!: any

  @Prop() alias!:string
  updateEditedItem() {
    this.$emit('update')
    this.$store.state.contractStore.editedItem = null
  }

  compare() {

  }

}
</script>

<style scoped>
.filter {
  position: relative;
  /*top: 0;*/
  /*left: 0;*/
  width: 100%;
  height: 100%;
  /* background: rgba(255, 255, 255, .75); */
  /*z-index: 9999;*/
  display: flex;
  justify-content: center;
  align-items: center;

  background-size: 4px 4px;
  background-image: radial-gradient(transparent 1px, rgba(255, 255, 255, .5) 1px);
  backdrop-filter: saturate(50%) blur(4px);
  /*backdrop-filter: blur(2px);*/
}
</style>
